import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import style from "./EntryForm.module.sass";
import { callApi } from "../../../../helpers";

function EntryForm(props) {
  const { newEntryPath, onSubmit, translations } = props;
  const [text, setText] = useState('');
  const [alertLevel, setAlertLevel] = useState("normal");

  const MAX_HEIGHT = 300;


  const toggleAlertLevel = () => {
    setAlertLevel((prev) => {
      if (prev === "normal") return "yellow";
      if (prev === "yellow") return "red";
      return "normal";
    });
  };

  const renderAlertIcon = () => {
    switch (alertLevel) {
      case "yellow":
        return "⚠️";
      case "red":
        return "🚨";
      default:
        return "➕";
    }
  };

  const onChange = (e) => {
    const textarea = e.target;

    textarea.style.height = "auto";

    if (textarea.scrollHeight > MAX_HEIGHT) {
      textarea.style.height = MAX_HEIGHT + "px";
      textarea.style.overflowY = "auto";
    } else {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden";
    }

    setText(textarea.value);
  };

  const onSubmitSuccess = () => {
    setText('');
    setAlertLevel("normal");
    onSubmit();
  };

  const onClickSubmit = (newValue) => {
    callApi(newEntryPath, "POST", "", onSubmitSuccess, null, null, {
      body: JSON.stringify({
        text: text,
        alert_level: alertLevel
      })
    });
  };

  const onClickCancel = () => {
    setText('');
    setAlertLevel("normal");
  }

  let rootClass = `${style.EntryForm} ${text.trim().length > 0 ? style.active : ''}`;

  return (
    <div className={rootClass}>
      <div className={style.bodyContainer}>
        <div className={style.text}>
          <textarea
            id="entry-textarea"
            value={text}
            onChange={onChange}
            placeholder={translations.placeholder}
          />
        </div>
        <div className={style.alertSelector} onClick={toggleAlertLevel} title={translations.tooltip}>
          {renderAlertIcon()}
        </div>
      </div>
      <div className={style.footer}>
        <div className={style.cancelButton} onClick={onClickCancel}>{translations.actions.cancel}</div>
        <div className={style.submitButton} onClick={onClickSubmit}>{translations.actions.save}</div>
      </div>
    </div>
  );
}

EntryForm.propTypes = {};

EntryForm.defaultProps = {};

export default EntryForm;
